// extracted by mini-css-extract-plugin
module.exports = {"avatar_input":"avatar-input_avatar_input__od6Ss","avatar":"avatar-input_avatar__G7p_p","input":"avatar-input_input__LjlTg"};